import Grid from '@mui/material/Grid2';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { useState } from 'react';
import PropTypes from 'prop-types';
import "./EGAutocomplete.scss";

const EGAutocomplete = ({
  label = '',
  initialValue = null,
  options = [],
  callback = (props = {}) => console.log(props),
  tag = '',
  errorMessage = '',
  margin = 0,
}) => {
  const [value, setValue] = useState(initialValue || null);

  const handleChange = (_, newValue) => {
    setValue(newValue);
    callback({ listElement: newValue });
  };

  return (
    <Autocomplete
      id={`${tag}-egautocomplete`}
      options={options}
      getOptionLabel={(option) => option.label || ''}
      value={value}
      onChange={handleChange}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          error={!!errorMessage}
          helperText={errorMessage}
        />
      )}
      sx={{ padding: '0', margin }}
    />
  );
};

EGAutocomplete.propTypes = {
  label: PropTypes.string,
  initialValue: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  options: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.object])),
  callback: PropTypes.func,
  tag: PropTypes.string,
  errorMessage: PropTypes.string,
  margin: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default EGAutocomplete;
